module.exports = __webpack_public_path__ + "img/data_moun_kc.74521105.png";